import {getInputControlMeta} from '@wix/wix-events-commons-statics'
import React from 'react'
import {Error} from '../../commons/error'
import {Label} from '../../commons/label'
import {Select} from '../../commons/select'
import fs from '../../fields.scss'
import {DropdownProps} from './interfaces'

export const Dropdown = ({input, control, meta: {dirty, touched, error}, t}: DropdownProps) => {
  const {options, label, mandatory} = getInputControlMeta(control)

  return (
    <div className={fs.field}>
      <Label classes={fs.customCaption} dataHook="dropdown-caption" required={mandatory} caption={label} />
      <Select options={options} value={input.value} ariaLabel={label} onChange={input.onChange} noDefaultValue={true} />
      <Error error={(dirty || touched) && error && t(error)} />
    </div>
  )
}
